(function($) {

  function showOpen() {
     $('article').each(function() {
      var status = $(this).find('.bar-hours');
      if (status.length > 0) {
        var info = window.mypubs.getBarStatus(status);
        if (!info.isOpen) {
          $(this).addClass('hidden');
        }
      }
     });
    $('#bars-list').removeClass('hidden');
    $('.items-loading').hide();
    window.mypubs.refreshMaps();
  }

  async function applyRatingFilter(article, value) {
    article.toggleClass('hidden', isNaN(value) || value < 4.5);
  }

  function reveal() {
    sortByRating();
    $('#bars-list').removeClass('hidden');
    $('.items-loading').hide();   
    window.mypubs.refreshMaps();
  }

  function sortByRating() {
    var container = $('#bars-list');
    container.find('article').sort(function(a, b) {
      var ratingA = parseFloat($(a).find('.bar-rating').attr('value'));
      var ratingB = parseFloat($(b).find('.bar-rating').attr('value'));
      if (isNaN(ratingA)) ratingA = 0;
      if (isNaN(ratingB)) ratingB = 0;
      return ratingB - ratingA;
    }).appendTo(container);
  }  

  async function showWithRating() {
    var pending = 0;
    $('article').each(function() {
      var article = $(this);
      var rating = article.find('.bar-rating');
      if (rating.length === 0) {
        return;
      }
      var value = parseFloat(rating.attr('value'));
      if (!isNaN(value)) {
        applyRatingFilter(article, value);
        return;
      }
      pending += 1;
      var observer = new MutationObserver(function() {
        var updated = parseFloat(rating.attr('value'));
        if (isNaN(updated)) {
          return;
        }
        observer.disconnect();
        applyRatingFilter(article, updated);
        pending -= 1;
        if (pending === 0) {
          reveal();
        }
      });
      observer.observe(rating[0], { attributes: true, attributeFilter: ['value'] });
    });
    if (pending === 0) {
      reveal();
    }
  }

  if (window.location.pathname.endsWith('open.html')) {
    showOpen();
  }

  if (window.location.pathname.endsWith('rating.html')) {
    showWithRating();
  }  

})(jQuery);